<!--Searchbar (none-md-and-up) toolbar has its own search item for md and up-->
<template>
  <span>
    <!--All but xs & sm-->
    <v-sheet
      class="fill-height py-0 d-none d-sm-flex.d-sm-none d-md-flex"
    >
      <v-container fluid class="fill-height d-flex align-center pa-0 h-100">
        <v-text-field
          class="searchbar pa-0"
          :loading="loading"
          density="compact"
          variant="solo"
          flat
          :label="searchLabel"
          append-inner-icon="mdi-magnify"
          hide-details
          v-model="searchInput"
          @click:append-inner="searchOnServer"
          @keyup.enter="searchOnServer"
          @keyup="updateSearchTerm"
        ></v-text-field>
      </v-container>
    </v-sheet>
    <!--xs & sm-->
    <v-container
      fluid
      class="searchbarmobile rounded-0 d-flex  align-center d-sm-none d-none d-sm-flex d-md-none py-0"
    >
        <v-text-field
          class="pa-0"
          :loading="loading"
          density="compact"
          variant="plain"
          :placeholder="searchLabel"
          append-inner-icon="mdi-magnify"

          v-model="searchInput"
          hide-details
          @keyup.enter="searchOnServer"
          @keyup="updateSearchTerm"
          @click:append-inner="searchOnServer"
        ></v-text-field>
    </v-container>
    <!-- v-menu withoud activator - just for positioning -->
    <v-menu
      v-model="showSearchPopup"
      :activator="'parent'"
      location="bottom"
      :close-on-content-click="false"
      width="auto"
      :open-on-click="false"
      :open-on-focus="false"
      :open-on-hover="false"
    >
      <v-card class="ma-3 searchResultPopupCard">
        <v-card-title class="primary contrast--text">
          {{ dataAll.getStatic("searching_result", "Search results for:") }}
          {{ searchInput }}
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text v-if="!busySearching">
          <div v-if="searchResults.sites && searchResults.sites.length > 0">
            {{ dataAll.getStatic("searching_result_pages", "Pages:") }}
            <v-list-item
              v-for="searchResultSite in searchResults.sites"
              v-bind:key="searchResultSite.id"
              color="primary"
              variant="plain"
            >
              <v-list-item-title>
                <NuxtLink
                  @click="hideSearchDialog"
                  class="text-lighttext text-decoration-none"
                  :to="searchResultSite.nameUrl"
                  >{{ searchResultSite.metaTitle }}
                </NuxtLink>
              </v-list-item-title>
            </v-list-item>
          </div>
          <div v-if="searchResults.articles && searchResults.articles.length > 0">
            {{ dataAll.getStatic("searching_result_articles", "Articles:") }}
            <v-list-item
              v-if="searchResults.articles"
              v-for="searchResultArticle in searchResults.articles"
              v-bind:key="searchResultArticle?.Head?.ArticleNumber"
              color="primary"
              variant="plain"
            >
              <v-list-item-title v-if="validArticle(searchResultArticle)">
                <NuxtLink
                  @click="hideSearchDialog"
                  class="text-lighttext text-decoration-none"
                  :to="$PAG.formatArticleUrl(searchResultArticle)"
                  >{{ searchResultArticle?.Head?.ArticleName }}
                </NuxtLink>
              </v-list-item-title>
            </v-list-item>    
          </div>    
          <div v-if="searchResults.vacancies && searchResults.vacancies.length > 0">
            {{ dataAll.getStatic("searching_result_vacancies", "Vacancies:") }}
            <v-list-item
              v-for="vacancy in searchResults.vacancies"
              :key="vacancy.id"
              color="primary"
              variant="plain"
            >
              <v-list-item-title>
                <NuxtLink
                  @click="hideSearchDialog"
                  class="text-lighttext text-decoration-none"
                  :to="getVacancyUrl(vacancy)"
                  >{{ vacancy.title }}
                </NuxtLink>
              </v-list-item-title>
            </v-list-item>
          </div>  
          <!-- No results message -->
          <div v-if="hasNoResults" class="text-center py-4">
            {{ dataAll.getStatic('search_server_no_results', "No results found") }}
          </div>

          <!-- Error message -->
          <div v-if="errorString" class="text-error text-center py-2">
            {{ errorString }}
          </div>
        </v-card-text>
        <v-card-text v-if="busySearching" class="text-center py-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="mt-2">{{ dataAll.getStatic("searching_busy", "Busy searching...") }}</div>
        </v-card-text>
      </v-card>
     </v-menu>
  </span>
</template>
<style scoped>
  .searchResultPopupCard {
    background-color:white !important;
  }

</style>
<script setup>

import { onMounted, onUpdated, onBeforeUnmount, onBeforeMount } from "vue";
import usePageTypeStore from '@/composables/usePageTypeStore';
import useSearchStore from '@/composables/useSearchStore';
import { useSiteSettingsStore } from "../../store/siteSettings";

const dataAll = useDataAll();
const siteSettings = useSiteSettingsStore();
const route = useRoute();
const { pageType } = usePageTypeStore();
const { isIntranet } = useIntranetAuth()
const { setSearchTerm } = useSearchStore();
const { $PAG,$apiMethods, $methods,$helpers } = useNuxtApp()

let loading = ref(false);
let busySearching = ref(false);
let searchInput = ref('');
let showSearchPopup = ref(false);
let searchAgain = false;
let searchResults = ref([]);
let errorString = ref("")
let searchLabel = ref(siteSettings.SearchBarText)


watch(pageType, (newVal, oldVal) => {
   setLabelSearchbar()
});
watch(
  () => route.fullPath,
  (newPath, oldPath) => {
    // route changed delete search term
    searchInput.value = ''
    showSearchPopup.value = false  // close popup
    updateSearchTerm()
  }
);

function getVacancyUrl(vacancy) {
  const vacancyBaseUrl = $methods.pageUrlByPageType('DV') === '/' ? '/vacancy' : $methods.pageUrlByPageType('DV');
  return `${vacancyBaseUrl}/${vacancy.slug}`;
}

onMounted(() => {
   setLabelSearchbar()
})

function updateSearchTerm(){
  setSearchTerm(searchInput.value);
}
function setLabelSearchbar(){
  if (isIntranet()){

    switch(pageType.value) {
      case 'DN':case 'NI':
        searchLabel.value = dataAll.getStatic("seach_intranet_news", "Search news")
        break;
      case 'DE':case 'EV':
        searchLabel.value = dataAll.getStatic("search_intranet_events", "Search events")
        break;
      case 'DV':case 'VA':
        searchLabel.value = dataAll.getStatic("search_intranet_vacancies", "Search vacancies")
        break;
      case 'DA':case 'AC':
        searchLabel.value = dataAll.getStatic("search_intranet_actions", "Search actions")
        break;
      case 'DR':case 'RE':
        searchLabel.value = dataAll.getStatic("search_intranet_references", "Search references")
        break;                
      case 'PS':case 'PM':case 'PG':
        searchLabel.value = dataAll.getStatic("search_intranet_products", "Search products")
        break;   
      case 'HP':
        searchLabel.value = dataAll.getStatic("search_intranet_help", "Search help")
        break; 
      case 'WP':
        searchLabel.value = dataAll.getStatic("search_intranet_whitepapers", "Search whitepapers")
        break;    
      case 'IT':
        searchLabel.value = dataAll.getStatic("search_intranet_phonebook", "Search phonebook")
        break;  
      case 'SD':
        searchLabel.value = dataAll.getStatic("search_intranet_pages", "Search pages")
        break;          
      default:
        searchLabel.value = dataAll.getStatic("search_intranet_all", "Search all")
    } 

  } else {
    searchLabel.value = siteSettings.SearchBarText
  }
}

function validArticle(articleObj){
  // check if an article has a valid name and number, so the link can be displayed properly
  return (articleObj?.Head?.ArticleNumber && articleObj?.Head?.ArticleName)
}


async function searchOnServer() {
    // only search if there is input
  if (!searchInput.value || !searchInput.value.trim()) {
    return;
  }
  if (!busySearching.value && pageType.value !== "IT") {
    showSearchPopup.value = true;
    busySearching.value = true;
    searchResults.value = [];
    loading.value = "primary";
    errorString.value = "";

    try {
      // Make api call
      const response = await $apiMethods.postApiCall(
        $apiMethods.getApiHostUrl() +
          "/api/" +
          $helpers.getLabelId() +
          "/search/" +
          dataAll.getLanguage(),
        {
          searchInput: searchInput.value,
          pageType: isIntranet()?pageType.value:'',
        }
      );

      // Validate response
      const isValid = $methods.checkObjectFieldsExists(
        response,
        ["sites"], 
        "searchJSON"
      );

      if (isValid) {
        searchResults.value = response;
        busySearching.value = false;
        loading.value = false;

        if (searchAgain) {
          searchAgain = false;
          await searchOnServer(); // Recursive call if needed
        }
      } else {
        throw new Error("Invalid response structure: Required fields missing.");
      }
    } catch (err) {
      // error handling
      console.error("Error during server search:", err.message);
      busySearching.value = false;
      errorString.value = dataAll.getStatic(
        "search_server_error",
        "Server Error while searching"
      );
      loading.value = false;
    }
  } else {
    // Mark to search again when results fetched
    searchAgain = true;
  }
}

function hideSearchDialog() {
  searchInput.value = "";
  showSearchPopup.value = false;
  searchResults.value = [];
  errorString.value = "";
}
const hasNoResults = computed(() => {
  if (!searchResults.value) return false;
  const hasSites = searchResults.value.sites && searchResults.value.sites.length > 0;
  const hasArticles = searchResults.value.articles && searchResults.value.articles.length > 0;
  const hasVacancies = searchResults.value.vacancies && searchResults.value.vacancies.length > 0;
  return !hasSites && !hasArticles && !hasVacancies && !errorString.value;
});

</script>
